// src/types/rbac.ts
// ERUE Festival Suite — RBAC type definitions (DROP 17)

export type Permission =
  | "system_admin"
  | "user_management"
  | "accounting"
  | "raffle"
  | "documents"
  | "communications"
  | "community_admin"
  | "registrations"
  | "voting"
  | "live_stream"
  | "sponsorship"
  | "dignitaries"
  | "programme"
  | "media"
  | "news_publishing"
  | "hero_images";

export type SystemRole =
  | "PLATFORM_ADMIN"
  | "FESTIVAL_COORDINATOR"
  | "ACCOUNTANT"
  | "SECRETARY"
  | "COMMUNITY_MANAGER"
  | "MEDIA_MANAGER"
  | "RAFFLE_MANAGER"
  | "REGISTRAR"
  | "VIEWER";

export interface RBACUser {
  id: string;
  name: string;
  email: string;
  role: SystemRole | string;
  permissions: Permission[];
  customRoleId?: string;
  active: boolean;
  createdAt: string;
  lastLogin?: string;
}

export interface CustomRole {
  id: string;
  name: string;
  description: string;
  permissions: Permission[];
  createdAt: string;
  createdBy: string;
}

export interface AuditEntry {
  id: string;
  userId: string;
  userEmail: string;
  action: string;
  target: string;
  detail: string;
  timestamp: string;
  ip?: string;
}

export const ALL_PERMISSIONS: Permission[] = [
  "system_admin", "user_management", "accounting", "raffle",
  "documents", "communications", "community_admin", "registrations",
  "voting", "live_stream", "sponsorship", "dignitaries",
  "programme", "media", "news_publishing", "hero_images"
];

export const PERMISSION_LABELS: Record<Permission, string> = {
  system_admin:     "System Administration",
  user_management:  "User Management",
  accounting:       "Accounting & Finance",
  raffle:           "Raffle Management",
  documents:        "Documents & Records",
  communications:   "Communications",
  community_admin:  "Community Administration",
  registrations:    "Registrations",
  voting:           "Voting System",
  live_stream:      "Live Stream Control",
  sponsorship:      "Sponsorship Management",
  dignitaries:      "Dignitaries Address Book",
  programme:        "Festival Programme",
  media:            "Media & Gallery",
  news_publishing:  "News Publishing",
  hero_images:      "Hero Images Control",
};

export const ROLE_PERMISSIONS: Record<SystemRole, Permission[]> = {
  PLATFORM_ADMIN:       ["system_admin","user_management","accounting","raffle","documents","communications","community_admin","registrations","voting","live_stream","sponsorship","dignitaries","programme","media","news_publishing","hero_images"],
  FESTIVAL_COORDINATOR: ["programme","registrations","community_admin","communications","dignitaries","news_publishing","media"],
  ACCOUNTANT:           ["accounting","raffle","sponsorship"],
  SECRETARY:            ["documents","communications","dignitaries","news_publishing"],
  COMMUNITY_MANAGER:    ["community_admin","media","news_publishing","dignitaries"],
  MEDIA_MANAGER:        ["media","live_stream","documents","news_publishing"],
  RAFFLE_MANAGER:       ["raffle"],
  REGISTRAR:            ["registrations","voting"],
  VIEWER:               [],
};

export const ROLE_DESCRIPTIONS: Record<SystemRole, string> = {
  PLATFORM_ADMIN:       "Full platform control — all 16 permissions",
  FESTIVAL_COORDINATOR: "Festival operations & community management",
  ACCOUNTANT:           "Financial records, raffle & sponsorship",
  SECRETARY:            "Documents, communications & dignitaries",
  COMMUNITY_MANAGER:    "Community portals, media & publishing",
  MEDIA_MANAGER:        "Media, live stream & news publishing",
  RAFFLE_MANAGER:       "Raffle draw management only",
  REGISTRAR:            "Registrations & voting management",
  VIEWER:               "Read-only access — no write permissions",
};
